module.exports = __webpack_public_path__ + "img/1.67f193c8.png";